import axios from 'axios'
export const BASE_URL = process.env.NODE_ENV === "development" ? 'http://thefunderstorms.com/newclients/sbdt/' : './'

export const requestData = (url, params, method = "GET", data) => axios({
  url,
  method,
  params,
  baseURL: BASE_URL,
  withCredentials: false,
  responseType: 'json',
  data
}).then(json => Promise.resolve(json.data))
  .catch((err) => Promise.reject(err.response.data))


// WEBPACK FOOTER //
// ./src/api/index.js